module.exports = __webpack_public_path__ + "assets/webgl/museum.18a65746.gltf";